import type { EnumUnion } from "@dresscode-frontend/utility-types";

import type { ApiSearchQuery } from "@/lib/api/api-type-helper";

import type {
  AllTableRow,
  InvitingTableRow,
  UserOperatorTableRow,
} from "./-types";

type QUERY = ApiSearchQuery<"/v2/settings/users", "get">;
type CATEGORY = Exclude<QUERY, undefined>["category"];
type CATEGORY_KEY = Exclude<CATEGORY, undefined>;

export const OperatorTabKey = {
  OPERATOR_MEMBERSHIP: "OPERATOR_MEMBERSHIP",
  OPERATOR_INVITATION: "OPERATOR_INVITATION",
} as const satisfies Record<
  Extract<CATEGORY_KEY, "OPERATOR_MEMBERSHIP" | "OPERATOR_INVITATION">,
  string
>;
export type OperatorTabKey = EnumUnion<typeof OperatorTabKey>;

export const IndividualTabKey = {
  INDIVIDUAL_MEMBERSHIP: "INDIVIDUAL_MEMBERSHIP",
  INDIVIDUAL_INVITATION: "INDIVIDUAL_INVITATION",
} as const satisfies Record<
  Extract<CATEGORY_KEY, "INDIVIDUAL_MEMBERSHIP" | "INDIVIDUAL_INVITATION">,
  string
>;

export type IndividualTabKey = EnumUnion<typeof IndividualTabKey>;

// TODO: 初期段階では実装しない機能
// type STATUS = Exclude<QUERY, undefined>["status"];
// export type STATUS_FILTER = Exclude<STATUS, undefined>;

// export const StatusFilter = {
//   ACTIVE: "ACTIVE",
//   SUSPENDED: "SUSPENDED",
// } as const satisfies Record<STATUS_FILTER, STATUS_FILTER>;
// export type StatusFilter = EnumUnion<typeof StatusFilter>;

// export const StatusFilterToDisplay = {
//   ACTIVE: "Active",
//   SUSPENDED: "Suspended",
// } as const satisfies Record<STATUS_FILTER, string>;
// export type StatusFilterDisplay = EnumUnion<typeof StatusFilterToDisplay>;

export const AllColumns = {
  PERSON: "person",
  WORKER_TYPE: "workerType",
  // RULE: "rule",
  // ROLES: "roles",
  STATUS: "status",
  MFA_STATUS: "mfaStatus",
  // AUTHENTICATION: "authentication",
  // PRICING_PLAN: "pricingPlan",
  // EXPIRY_DATE: "expiryDate",
  ACTIVATION_DATE: "activationDate",
} as const satisfies Record<string, keyof AllTableRow>;

export const InvitingColumns = {
  PERSON: "person",
  WORKER_TYPE: "workerType",
  INVITED_DATE: "invitedDate",
  EXPIRY_DATE: "expiryDate",
  IS_EXPIRED: "isExpired",
} as const satisfies Record<string, keyof InvitingTableRow>;

type ORDER_BY = Exclude<QUERY, undefined>["orderBy"];
export type ORDER_BY_FILTER = Extract<ORDER_BY, "PERSON" | "WORKER_TYPE">;

export const SortColumns = [
  "PERSON",
  "WORKER_TYPE",
] as const satisfies ORDER_BY_FILTER[];

export type SORTABLE_COLUMNS = Extract<
  keyof UserOperatorTableRow,
  "person" | "workerType"
>;

export const ColumnsToSortColumns = {
  person: "PERSON",
  workerType: "WORKER_TYPE",
} as const satisfies Record<SORTABLE_COLUMNS, ORDER_BY_FILTER>;

export const SortColumnsToColumns = {
  PERSON: "person",
  WORKER_TYPE: "workerType",
} as const satisfies Record<ORDER_BY_FILTER, SORTABLE_COLUMNS>;

export const MemberShipTypes = [
  { id: "operator", label: "Operator" },
  { id: "individual", label: "Individual" },
] as const satisfies { id: string; label: string }[];

export type MEMBERSHIP_TYPE_KEY = (typeof MemberShipTypes)[number]["id"];

export const MemberShipTypesToRequest = {
  operator: "OPERATOR",
  individual: "INDIVIDUAL",
} as const satisfies Record<MEMBERSHIP_TYPE_KEY, string>;
